import { useState } from "react";
import Accordeon from "components/accordeon";
import StyleWrapper, {
    StyleContentWrapper,
    StyleTitlePage,
    StyleAccordeonWrapper,
} from "./style";

export default ({setIsModalOpen}) => {
        
    const faqQuestions = [
        {
            title: "Qual o período de participação da promoção?",
            content:
                "A promoção acontece de 25 de outubro de 2025 a 25 de janeiro de 2026.",
        },
        {
            title: "Quem pode participar da promoção?",
            content:
                "Podem participar pessoas físicas, maiores de 18 anos, com CNH válida durante todo o período da promoção, residentes no Brasil e que realizem o Best Drive conforme o regulamento.",
        },
        {
            title: "Quais são os veículos participantes da promoção?",
            content:
                "A lista completa dos veículos participantes está disponível no regulamento. Entre os modelos elegíveis estão Saveiro, Novo Polo, Virtus, Nivus, T-Cross, Tiguan All Space, Jetta GLI, Taos e Amarok.",
        },
        {
            title: "Como faço para participar?",
            content: (
                <>
                    <p>1. Vá até uma concessionária Volkswagen participante.</p>
                    <p>2. Apresente sua CNH válida.</p>
                    <p>
                        3. O consultor Volkswagen fará seu cadastro com seus
                        dados e foto da CNH.
                    </p>
                    <p>
                        4. Realize o Best Drive (mínimo de 1 km, máximo de
                        1h30).
                    </p>
                    <p>
                        5. Ao final, responda à pesquisa de satisfação e
                        confirme sua participação na promoção
                    </p>
                </>
            ),
        },
        {
            title: "Quantos números da sorte eu recebo?",
            content: (
                <p>
                    Cada participante tem direito a 1 número da sorte por CPF, independentemente da quantidade de Best Drives realizados.
                </p>
            ),
        },
        {
            title: "Preciso me cadastrar em algum site?",
            content:
                "Não. O cadastro é feito exclusivamente pelo consultor Volkswagen na concessionária.",
        },
        {
            title: "Quando e onde receberei meus números da sorte?",
            content:
                "Seu número da sorte ficará disponível para consulta no site www.bestdrivepremiadovw.com.br, após a realização do Best Drive na concessionária.",
        },
        {
            title: "Como funciona o sorteio?",
            content:
                "O sorteio será baseado na Loteria Federal do dia 07 de Fevereiro de 2026. Serão sorteados 10 participantes, e cada um ganhará um Volkswagen Tera 2025 0 km.",
        },
        {
            title: "Como sei se fui um dos ganhadores?",
            content:
                "A lista de ganhadores será publicada no site www.bestdrivepremiadovw.com.br e nas redes sociais oficiais da Volkswagen até 28 de fevereiro de 2026.",
        },
        {
            title: "Como será feita a entrega do prêmio?",
            content:
                "O veículo será entregue na concessionária Volkswagen mais próxima do endereço informado no cadastro, em até 30 dias após a validação do resultado.",
        },
        {
            title: "Tenho mais dúvidas. Com quem posso falar?",
            content:
                "Entre em contato com a Central de Relacionamento Volkswagen pelo site www.vw.com.br/fale-conosco ou procure a concessionária mais próxima.",
        },
    ];
    return (
        <>
            <StyleWrapper>
                <StyleContentWrapper>
                    <StyleTitlePage>Perguntas frequentes</StyleTitlePage>
                    <StyleAccordeonWrapper>
                        {faqQuestions.map((item, index) => (
                            <Accordeon
                                title={item.title}
                                groupName="faqquestion"
                                index={index}
                                key={`faqquestion${index}`}
                            >
                                {item.content}
                            </Accordeon>
                        ))}
                    </StyleAccordeonWrapper>
                    <div>
                        <p>
                            Período de participação: de 11/05/2025 a 11/08/2026.
                            Serão considerados válidos apenas os teste drives realizados nas concessionárias participantes e que atendam aos parâmetros descritos no regulamento, limitado a um prêmio por CPF. 
                            Certificado de autorização N.° 04.049765/2026.
                        </p>
                    </div>
                </StyleContentWrapper>
            </StyleWrapper>
        </>
    );
};
